import { z } from "zod";
import { PERSONA_INFLUENCES } from "./vocabulary.js";
// Canonical shape of an artist's persona (spec §4.2). Hybrid model: a free-text
// `bio` (editorial only — NEVER rendered into the prompt) plus the structured
// `temperament`/`influences` that DO feed the prompt. All fields optional; `{}`
// is a valid "no persona" value — the zero-regression baseline.
export const personaTemperamentSchema = z.object({
    discipline: z.number().int().min(1).max(5).optional(),
    boldness: z.number().int().min(1).max(5).optional(),
    experimental: z.number().int().min(1).max(5).optional(),
});
export const artistPersonaSchema = z.object({
    // Free text, EDITORIAL — shown in the UI, NEVER enters the prompt (§5.3).
    bio: z.string().max(600).optional(),
    // Structured — feeds the prompt (§5).
    temperament: personaTemperamentSchema.optional(),
    influences: z.array(z.enum(PERSONA_INFLUENCES)).max(3).optional(),
});
//# sourceMappingURL=schema.js.map